import { render } from "./App.vue?vue&type=template&id=18704258"
const script = {}

import exportComponent from "/var/www/web/httpd/getsmartrx.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__